import { ArrowRight, CheckCircle2, FileText, ListChecks, Users } from "lucide-react";
import { Link } from "react-router-dom";

import { LogoMark } from "../components/LogoMark";
import { useAuth } from "../lib/auth";

export function LandingPage() {
  const { user } = useAuth();

  return (
    <main className="landing-page">
      <header className="landing-nav">
        <Link to="/" className="brand-mark">
          <LogoMark />
          <span>CosaFlow</span>
        </Link>
        <Link className="button button-secondary" to={user ? "/app" : "/login"}>
          {user ? "Open workspace" : "Sign in"}
          <ArrowRight size={17} />
        </Link>
      </header>

      <section className="landing-hero">
        <div className="hero-copy">
          <p className="eyebrow">The workspace for buying a home</p>
          <h1>CosaFlow</h1>
          <p>
            Replace scattered emails, PDFs, notes, and spreadsheets with one calm place for every
            property you are seriously considering.
          </p>
          <div className="hero-actions">
            <Link className="button button-primary" to={user ? "/app" : "/login"}>
              Start organizing
              <ArrowRight size={17} />
            </Link>
          </div>
        </div>

        <div className="product-preview" aria-label="CosaFlow product preview">
          <div className="preview-sidebar">
            <span />
            <span />
            <span />
            <span />
          </div>
          <div className="preview-main">
            <div className="preview-title">
              <div>
                <strong>123 Main St.</strong>
                <p>Offer due tomorrow</p>
              </div>
              <span className="status-pill">Preparing offer</span>
            </div>
            <div className="preview-grid">
              <div className="preview-card">
                <ListChecks size={18} />
                <strong>Tasks</strong>
                <p>Inspection call, lender docs, disclosure review</p>
              </div>
              <div className="preview-card">
                <FileText size={18} />
                <strong>Documents</strong>
                <p>Disclosures, preapproval, offer package</p>
              </div>
              <div className="preview-card">
                <Users size={18} />
                <strong>Contacts</strong>
                <p>Agent, lender, inspector, escrow</p>
              </div>
            </div>
            <div className="preview-timeline">
              <span>
                <CheckCircle2 size={16} /> Viewed property
              </span>
              <span>
                <CheckCircle2 size={16} /> Offer draft started
              </span>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
